import { render, staticRenderFns } from "./CbsDynamicForm.vue?vue&type=template&id=154dd97f&"
import script from "./CbsDynamicForm.vue?vue&type=script&lang=js&"
export * from "./CbsDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports